import React, { useState } from 'react'
import { SEO } from '../../components/SEO';
import { FAQSchema, OrganizationSchema, WebSiteSchema, HowToBookSchema } from '../../components/StructuredData';
import LandingMain2 from '../../components/Landing/LandingMain2'
import KeyBenefitExample from '../../components/Landing/KeyBenefitExample'
import LearningSteps from '../../components/Landing/LearningSteps'
import Footer from '../../components/Landing/Footer'
import Findtutors from '../../components/Findtutors'
import SubjectsData from '../Curriculum/Subjects/SubjectData'
import Testimonials from '../../components/Testimonials'
import TeacherTestimonials from '../../components/Testimonials/TeacherTestimonials'
import Accordian from '../../components/Accordian'
import { Faqs } from '../../data/Faqs'



const NewLanding = () => {
  const [showTeacher,setShowTeacher] = useState(false)
  return ( 
    <>
    {/* SEO Meta Tags */}
    <SEO 
      title="Find Best Online Tutors - Personalized 1-on-1 Learning"
      description="Connect with expert tutors worldwide for personalized one-on-one tutoring. Get help in math, science, languages & more. Book free trial today!"
      keywords="online tutoring, find tutor, one on one tutoring, mathematics tutor, science tutor, language tutor, education, learning, personalized tutoring"
      url="/"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'WorldoTutor - Find Best Online Tutors',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'WorldoTutor - Find Best Online Tutors'
        }
      }}
      geo={{
        region: 'IN',
        position: '30.9;75.8'
      }}
    />
    
    {/* Structured Data for Rich Snippets */}
    <OrganizationSchema />
    <WebSiteSchema />
    <FAQSchema />
    <HowToBookSchema />
    
    <div className="">
       <LandingMain2/>
    </div>
    <div className=' mx-auto py-8'>
       <h2 className='text-5xl font-bold text-center pb-8'>Key Benefits</h2>
      <KeyBenefitExample/>
    </div>
    <div className='pb-10'>
      <LearningSteps/>
    </div>

    <div id="explore" className='pb-16 pt-8  bg-gray-50 c'>
     
     <div className='py-12  text-center max-w-2xl mx-auto'>
     <h2 className='h1 '>Explore Our Online Classes  By Category</h2>
     <p className='pt-2 text-lg md:text-xl'>From core academics to enrichment programs, we offer personalized tutoring across all subjects.</p>
     </div>
      <SubjectsData/>
    </div>

    <div className="" id="findTutor">
          {/* <FindTutor /> */}
        <Findtutors/>
          
        </div>
         
         <div className='py-10 bg-gray-50' id="testimonials">
             {/* Toggle between Parent and Teacher Testimonials */}
             <div className="flex flex-col items-center">
               <div className="flex gap-2 mb-8 bg-neutral-100 rounded-lg p-1">
                 <button
                   className={`px-6 py-2 rounded-md font-medium transition-colors ${
                     !showTeacher ? 'bg-secondary text-white shadow' : 'bg-transparent text-primary'
                   }`}
                   onClick={() => setShowTeacher(false)}
                 >
                   Parents&rsquo; Overview
                 </button>
                 <button
                   className={`px-6 py-2 rounded-md font-medium transition-colors ${
                     showTeacher ? 'bg-secondary text-white shadow' : 'bg-transparent text-primary'
                   }`}
                   onClick={() => setShowTeacher(true)}
                 >
                   Tutor Experiences
                 </button>
               </div>
               <div className="w-full">
                 {showTeacher ? <TeacherTestimonials /> : <Testimonials />}
               </div>
             </div>
         </div>
          {/* <div className=' py-10 bg-primary text-white'>
            <Testimonials/>
          </div>
          <div className=' py-10 bg-secondary text-white'>
            <TeacherTestimonials/>
          </div> */}
          <div className=' py-12 ' id="faqs">
             <div className='container mx-auto'>
               <h2 className='h1 text-center pb-10'>Frequently Asked Questions</h2>
             <Accordian data={Faqs}/>
             </div>
          </div>
    <div className="bg-neutralBlack" id="footer">
          <Footer />
        </div>
    </>
  )
}

export default NewLanding
